var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from 'react-dom';
import '@webcomponents/webcomponentsjs/webcomponents-bundle';
import '@webcomponents/webcomponentsjs/custom-elements-es5-adapter.js';
var WebComponentWrapperElement = /** @class */ (function (_super) {
    __extends(WebComponentWrapperElement, _super);
    function WebComponentWrapperElement() {
        var _this = _super.call(this) || this;
        _this.ReactComponent = {};
        _this.observer = new MutationObserver(function () { return _this.update(); });
        _this.observer.observe(_this, { attributes: true });
        return _this;
    }
    WebComponentWrapperElement.prototype.connectedCallback = function () {
        this.mount();
    };
    WebComponentWrapperElement.prototype.disconnectedCallback = function () {
        this.unmount();
        this.observer.disconnect();
    };
    WebComponentWrapperElement.prototype.update = function () {
        this.unmount();
        this.mount();
    };
    WebComponentWrapperElement.prototype.mount = function () {
        var ReactComponent = this.ReactComponent;
        var props = __assign(__assign({}, this.getProps(this.attributes, ReactComponent.propTypes)), this.getEvents(ReactComponent.propTypes));
        ReactDOM.render(_jsx(ReactComponent, __assign({}, props)), this);
    };
    WebComponentWrapperElement.prototype.unmount = function () {
        ReactDOM.unmountComponentAtNode(this);
    };
    WebComponentWrapperElement.prototype.getEvents = function (propTypes) {
        var _this = this;
        if (!propTypes) {
            return {};
        }
        return Object.keys(propTypes)
            .filter(function (key) { return /on([A-Z].*)/.exec(key); })
            .reduce(function (events, ev) {
            var _a;
            return (__assign(__assign({}, events), (_a = {}, _a[ev] = function (args) {
                return _this.dispatchEvent(new CustomEvent(ev, __assign({}, args)));
            }, _a)));
        }, {});
    };
    WebComponentWrapperElement.prototype.getProps = function (attributes, propTypes) {
        var _this = this;
        propTypes = propTypes || {};
        return __spreadArray([], attributes, true).filter(function (attr) { return attr.name !== 'style'; })
            .map(function (attr) { return _this.convert(propTypes, attr.name, attr.value); })
            .reduce(function (props, prop) {
            var _a;
            return (__assign(__assign({}, props), (_a = {}, _a[prop.name] = prop.value, _a)));
        }, {});
    };
    WebComponentWrapperElement.prototype.convert = function (propTypes, attrName, attrValue) {
        var propName = Object.keys(propTypes).find(function (key) { return key.toLowerCase() === attrName; });
        var value = attrValue;
        if (attrValue === 'true' || attrValue === 'false') {
            value = attrValue === 'true';
        }
        else if (!isNaN(attrValue) && attrValue !== '') {
            value = +attrValue;
        }
        else if (/^{.*}/.exec(attrValue)) {
            value = JSON.parse(attrValue);
        }
        return { name: propName ? propName : attrName, value: value };
    };
    return WebComponentWrapperElement;
}(HTMLElement));
export { WebComponentWrapperElement };
